"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowCard = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var background_svg_1 = __importDefault(require("../../assets/images/background.svg"));
var Card_1 = __importDefault(require("@mui/material/Card"));
var Spinner_1 = require("../Spinner/Spinner");
var Utility_1 = require("./Utility");
var base_1 = require("@mui/base");
/**
 * Component that renders the workflow card that is used for all screen components.
 *
 * @param loading boolean value for isLoading
 * @param backgroundImage to display card background
 *
 * @category Component
 */
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        card: ['card'],
    };
    return (0, base_1.unstable_composeClasses)(slots, Utility_1.getWorkflowCardUtilityClass, classes);
};
var WorkflowCard = function (props) {
    var loading = props.loading, backgroundImage = props.backgroundImage, sx = props.sx, children = props.children, otherBoxProps = __rest(props, ["loading", "backgroundImage", "sx", "children"]);
    var defaultClasses = useUtilityClasses(props);
    return (react_1.default.createElement(Box_1.default, __assign({ sx: __spreadArray([
            {
                height: '100vh',
                width: '100%',
                backgroundColor: function (theme) { return (theme.palette.mode === 'light' ? 'primary.main' : 'primary.dark'); },
                backgroundImage: backgroundImage ? "url(".concat(backgroundImage, ")") : "url(".concat(background_svg_1.default, ")"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }
        ], (Array.isArray(sx) ? sx : [sx]), true), className: defaultClasses.root, "data-testid": defaultClasses.root }, otherBoxProps),
        react_1.default.createElement(Card_1.default, { sx: {
                width: '100%',
                height: '100%',
                maxWidth: { sm: '450px', xs: 'none' },
                maxHeight: { sm: '730px', xs: 'none' },
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                borderRadius: { xs: 0, sm: '4px' },
            }, className: defaultClasses.card, "data-testid": defaultClasses.card },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Spinner_1.Spinner, { "data-testid": "blui-spinner", visible: loading }),
                children))));
};
exports.WorkflowCard = WorkflowCard;
